module.exports = __webpack_public_path__ + "img/A1.090c8de8.jpg";